import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from '@Redux/type';
import { AppState } from '@Redux/store';
import UserBugReportForm from './user-bug-report.form';
import { FloatingContainer } from './user-bug-report.component.styled';
import { UserBugReportNewPresenter } from '@Selectors/user/user-bug-report.new.presenter';
import { CreateUserBugReportParams } from './user-bug-report.validate';
import { container } from '@Container';
import { UserBugReportAction } from '@Redux/actions/user/user-bug-report.action';
import { TYPES } from '@Types';

interface UserBugReportComponentProps {
  onClose: () => void;
}

const UserBugReportComponent: React.FC<Props> = (
  {
    datas,
    onClose,
    handleSubmit
  }
) => {
  const [isBigOpen, setIsBigOpen] = React.useState(false);

  const submit = (values: CreateUserBugReportParams) => handleSubmit(values, onClose);

  return (
    <FloatingContainer className="card-border" isBig={isBigOpen}>
      <div>
        {!isBigOpen && (<i className="fa-solid fa-maximize" onClick={() => setIsBigOpen(true)}></i>)}
        {isBigOpen && (<i className="fa-solid fa-minimize" onClick={() => setIsBigOpen(false)}></i>)}
        <UserBugReportForm cancel={onClose}
                           onSubmit={submit}
                           canSubmit={datas.canSubmit}
                           reasonTypes={datas.reasonTypes}
                           armyId={datas.armyId}
                           units={datas.units} />
      </div>
    </FloatingContainer>
  );
};

const mapStateToProps = (state: AppState) => ({
  datas: UserBugReportNewPresenter(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const action = container.get<UserBugReportAction>(TYPES.Actions.User.UserBugReportAction);
  return {
    handleSubmit: (values: CreateUserBugReportParams, onClose: () => void) => dispatch(action.create(values, onClose))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserBugReportComponent);

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps> &
  UserBugReportComponentProps
